import React from 'react'
import { aaplesarkar, Cidco, digitalindia, India, india111, maharashtra, makeinindia, mfs, mumbai, NMMRDA, NMMRDA111, NNgMRDA, NNMRDA, NPMRDA } from '../../../public/LoginImages/importimages'

const AboutUS = () => {
  return (
    <div style={{width:'100%',}}>
      <div style={{ display: 'flex', padding: '20px', }}>
        <div className='container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1rem' }}>
          <h1 style={{ textAlign: 'center' }}>नगर विकास विभागाविषयी</h1>
          <div class="clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__item"><img class="img-fluid align-center" src={mumbai} /><p>महाराष्ट्र राज्यातील एकूण लोकसंख्येपैकी जवळपास 4८ % लोकसंख्या ही नागरी विभागात येत असून, या सर्व लोकसंख्येच्या दैनंदिन गरजांशी संबंधीत विभाग म्हणून नगर विकास विभाग हा एक महत्त्वाचा विभाग आहे.&nbsp;</p><p>नागरी जीवनाशी संबंधीत दैनंदिन प्रश्न देखील दिवसेंदिवस वाढत असून, शहरी भागातील वाहतूक, घरांची समस्या, पाणीपुरवठा, घनकचरा व्यवस्थापन इत्यादी विषय अतिशय महत्त्वाचे झाले आहेत. या सर्व समस्यांचे निराकरण करण्यासाठी विविध योजना व सुधारणांची आवश्यकता असून, या संबंधातील बऱ्याच योजना शासनाने हाती घेतल्या आहेत.&nbsp;</p><p>महाराष्ट्रात एकूण २७ &nbsp;महानगर पालिका असून, 1७ अ वर्ग नगरपरिषदा, 73 ब वर्ग नगरपरिषदा व 150 क वर्ग नगरपरिषदा आहेत. या व्यतिरिक्त एकूण 125 नगरपंचायती देखिल आहेत. उपरोक्त नमूद केलेल्या एकूण 2७ महानगर पालिका व ३65 नगरपरिषदा / नगरपंचायती व्यतिरिक्त नगर विकास विभागाच्या नियंत्रणाखालील शहर व औद्योगिक विकास महामंडळ (सिडको), मुंबई महानगर प्रदेश विकास प्राधिकरण (MMRDA), पुणे महानगर प्रदेश विकास प्राधिकरण &nbsp;(PMRDA), नागपूर महानगर प्रदेश विकास प्राधिकरण (NMRDA), औरंगाबाद महानगर प्रदेश विकास प्राधिकरण (AMRDA), नाशिक महानगर प्रदेश विकास प्राधिकरण (NMRDA), &nbsp;नगररचना व मुल्य निर्धारण संचालनालय, नगर पालिका प्रशासन संचालनालय, अग्निशमन सल्लागार कार्यालय, नागपूर सुधार प्रन्यास व 9 नागरी कमाल जमिन धारणा (निरसन) अधिनियम 1999 चे कामकाज हाताळणारी कार्यालये येतात.&nbsp;</p><p>नागरी भागाच्या विकासाशी निगडीत असलेला नगर विकास विभाग व या विभागाच्या नियंत्रणाखाली असलेली विविध कार्यालये / उपक्रम यांची जबाबदारी लक्षात घेता या विभागास अनन्य साधारण महत्त्व प्राप्त झाले आहे. नगर विकास विभागांतर्गत उपलब्ध सेवांचा तपशील, त्या पुरविण्यासाठी आवश्यक ती कालमर्यादा, सेवा पुरविणारा अधिकारी व सदरचा लाभ मिळण्यास अडचण निर्माण झाल्यास नागरिकांनी संपर्क साधण्याकरिता अधिकारी इत्यादींची माहिती दर्शविणारे हे संकेतस्थळ आहे</p><p>त्यामुळे नगर विकास विभाग अधिक गतिमान, पारदर्शक, जबाबदार व लोकाभिमुख होण्यास मदत होईल.&nbsp;</p></div>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <div style={{ display: 'grid', gap: '30px' }}>
            <h5 className="text-center">
              <strong style={{ display: 'flex', justifyContent: 'center', fontSize: '25px' }}>अधिनस्त कार्यालये</strong>
            </h5>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
              <div>
                <a href="/mfs">
                  <img src={mfs} alt="" style={{ width: '8rem', maxWidth: '100%' }} />
                </a>
                <br />
                <strong>अग्निशमन विभाग</strong>
              </div>
              <div style={{ paddingTop: '18px' }}>
                <img src={Cidco} alt="" style={{ width: '8rem', maxWidth: '100%' }} />
                <br />
                <strong>सिडको (C I D C O)</strong>
              </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
              <div>
                <a href="/dtp">
                  <img src={maharashtra} alt="" style={{ width: '8rem', maxWidth: '100%' }} />
                </a>
                <br />
                <a href="/dtp">
                  <strong>नगररचना विभाग</strong>
                </a>
              </div>
              <div>
                <a href="/dma">
                  <img src={maharashtra} alt="" style={{ width: '8rem', maxWidth: '100%' }} />
                </a>
                <br />
                <a href="/dma">
                  <strong>नगरपरिषद संचालनालय</strong>
                </a>
              </div>
            </div>
            <h5 style={{ display: 'flex', justifyContent: 'center', fontSize: '25px' }}>प्रमुख नगर विकास प्राधिकरण</h5>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
              <div>
                <a href="/dtp">
                  <img src={NMMRDA111} alt="" style={{ width: '8rem', maxWidth: '100%' }} />
                </a>
                <br />
                <a href="/dtp" style={{ textDecoration: 'none' }}>
                  <strong style={{ display: 'flex', justifyContent: 'center', color: 'black' }}>मुंबई महानगर<br /> विकास प्राधिकरण</strong>
                </a>
              </div>
              <div>
                <a href="/dma">
                  <img src={NMMRDA} alt="" style={{ width: '8rem', maxWidth: '100%' }} />
                </a>
                <br />
                <a href="/dma" style={{ textDecoration: 'none' }}>
                  <strong style={{ display: 'flex', justifyContent: 'center', color: 'black' }}>नाशिक महानगर<br /> विकास प्राधिकरण </strong>
                </a>
              </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
              <div>
                <a href="/dtp">
                  <img src={NNgMRDA} alt="" style={{ width: '8rem', maxWidth: '100%' }} />
                </a>
                <br />
                <a href="/dtp" style={{ textDecoration: 'none' }}>
                  <strong style={{ display: 'flex', justifyContent: 'center', color: 'black' }}>नागपूर महानगर<br /> विकास प्राधिकरण </strong>
                </a>
              </div>
              <div>
                <a href="/dma">
                  <img src={NPMRDA} alt="" style={{ width: '8rem', maxWidth: '100%' }} />
                </a>
                <br />
                <a href="/dma" style={{ textDecoration: 'none' }}>
                  <strong style={{ display: 'flex', justifyContent: 'center', color: 'black' }}>पुणे महानगर<br /> विकास प्राधिकरण </strong>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div>
        <footer style={{ backgroundColor: "#2f4f4f", padding: "20px 0", textAlign: "center" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div style={{ display: "flex", justifyContent: "space-around", flexWrap: "wrap", padding: '4rem 0px' }}>
              <section>
                <a href="https://india.gov.in">
                  <img src={india111} alt="India" width="200" height="150" loading="lazy" />
                </a>
              </section>
              <section>
                <a href="https://aaplesarkar.maharashtra.gov.in/">
                  <img src={aaplesarkar} alt="Aaple Sarkar" width="200" height="150" loading="lazy" />
                </a>
              </section>
              <section>
                <a href="https://digitalindia.gov.in/">
                  <img src={digitalindia} alt="Digital India" width="200" height="150" loading="lazy" />
                </a>
              </section>
              <section>
                <a href="https://makeinindia.com">
                  <img src={makeinindia} alt="Make in India" width="200" height="150" loading="lazy" />
                </a>
              </section>
            </div>

            <div style={{ marginTop: "20px", borderTop: "1px solid #ddd", paddingTop: "10px", fontSize: "14px" }}>
              <div style={{ display: "flex", justifyContent: "end", flexWrap: "wrap" }}>
                <div style={{ fontSize: '17px', minWidth: "250px", color: '#fffc' }}>
                  2020 &copy; <a href="https://softmatesystems.com/" style={{ color: '#fffc' }}>All rights reserved by Softmate Systems LLP.</a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>

    </div>


  )
}

export default AboutUS
